<template>
  <custom-dialog width="530px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <el-form-item key="timeZoneId" :label="$t('location_timeZone_dialog.shi_qu')" :rules="rules.timeZoneId"  prop="timeZoneId">
          <custom-select
            v-model="form.timeZoneId"
            url="timeZoneGetCompanyList"
            :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      selectRow: {},
      form: {
        timeZoneId: '',
      },
      rules: {
        timeZoneId: { required: true,
          message: this.$t('Common.com_required') },
      },
    };
  },
  mounted() {
  },
  methods: {
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'update') {
          this.saveUpdate();
        }
      });
    },

    // 保存编辑
    saveUpdate: function () {
      this.form.locationIds = this.model.data.map(item => item.locationId);
      this.$postJSON(apis.locationUpdateTimeZone, this.form, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
